<template lang="pug">
	.confirm-dialog(v-if="showed && options")
		.card(:style="{height: options.height || '190px'}")
			.card-header(:style="{height: 'auto'}")
				i.fa.fa-edit
				span {{options.caption || 'Confirm'}}
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label(v-html="options.message || 'Are you sure?'")
					.form-actions
						button.btn.btn-danger(type="submit" v-on:click="confirm()")
							.icon.fa(:class="options.confirmButtonIcon")
							span(v-html="options.confirmButtonText || 'Confirm'")
						button.btn.btn-ghost-dark(type="button" v-on:click="cancel()") {{options.cancelButtonText || 'Cancel'}}
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Project } 			from './../../services/Project';
	import { Settings } 		from './../../services/Settings';

	export default {
		name: "Confirm",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Project = Project;
			this.Settings = Settings;

			this.options = {};

			return {

			};

		},
		mounted() {

			window.addEventListener("keydown", e => {

				if (this.showed) {

					if (e.keyCode === 27 && e.target.tagName !== 'INPUT') this.hide();

				}

			});

		},
		methods: {
			collectData(reason, options) {

				if (reason === 'show') {

					this.options = options;

					if (options.forceConfirm) this.confirm();

				}

			},
			confirm() {

				if (this.options.confirmCallback) this.options.confirmCallback();

				this.hide();

			},
			cancel() {

				if (this.options.cancelCallback) this.options.cancelCallback();

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.confirm-dialog
		display: flex
		align-items: center
		justify-content: center
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark
				float: right
				color: #fff

</style>

